<template>
  <!-- isi cart -->
  <div class="cart row">
    <div class="col">
      <div class="img-hover-zoom">
        <img :src="getImagePath()" @error="fallback" class="card-img-top" alt="...">
      </div>
    </div>
    <div class="col">
      <h4>{{cart.Product.name}}</h4>
      <div class="text-left">
        <p class="cart-info">Category : {{cart.Product.category}}</p>
        <p class="cart-info">Stock : <span :style="{ color }">{{stockFormat(cart.Product.stock)}}</span></p>
        <p class="cart-info">Price : {{currFormat(cart.Product.price)}}</p>
      </div>
      <div class="cart-btn">
        <button @click="removeCart(cart.id)" class="btn btn-danger"><b-icon icon="trash"></b-icon></button>
        <b-icon @click="decreaseCart(cart.id)" icon="file-minus-fill" v-if="!outStock" class="icon"></b-icon>
        <input v-if="!outStock" type="text" :value="cart.quantity" placeholder="0" disabled>
        <b-icon @click="increaseCart(cart.id)" icon="file-plus-fill" v-if="!outStock" class="icon"></b-icon>
      </div>
    </div>
  </div>
  <!-- end isi cart -->
</template>

<script>
export default {
  props: ['cart'],
  data () {
    return {
      onErr: false,
      outStock: false,
      color: ''
    }
  },
  methods: {
    currFormat (currency) {
      return currency.toLocaleString()
    },
    stockFormat (stock) {
      let format
      if (stock > 0) {
        format = stock
      } else {
        format = 'out of stock'
        this.color = 'red'
        this.outStock = true
      }
      return format
    },
    fallback () {
      this.onErr = true
    },
    getImagePath () {
      return (this.onErr) ? 'https://i.imgur.com/0GbE4Oc.jpg' : this.cart.Product.image_URL
    },
    increaseCart (id) {
      this.$store.dispatch('increaseCart', id)
    },
    decreaseCart (id) {
      if (this.cart.quantity > 1) {
        this.$store.dispatch('decreaseCart', id)
      } else {
        this.removeCart(id)
      }
    },
    removeCart (id) {
      this.$store.dispatch('removeCart', id)
    }
  }
}
</script>

<style scoped>
  .btn {
    margin-right: 10px;
  }
  input {
    text-align: center;
    display: inline;
    width: 50px;
    outline: 0;
    border-width: 0 0 2px;
    border-color: green
  }
  .cart {
    width: 100%;
    padding: 10px;
    margin: 10px auto;
    box-shadow: 0 0 5px 1px #1e524b;
    transition: 50ms;
  }
  .cart:hover {
    box-shadow: 0 0 10px 2px #1e524b;
    margin-top: -3px;
    margin-bottom: 13px;
    transition: 100ms;
  }
  .cart:hover .card-img-top {
    transition: 200ms;
    transform: scale(1.1);
  }
  .cart-btn {
    position: absolute;
    bottom: 0px;
    right: 0px;
  }
  .cart-info {
    margin: 0;
  }
  .card-img-top {
    width: 200px;
    height: 200px;
    transition: 200ms;
  }
  .icon {
    font-size: 20px;
    margin:2px;
    color: green;
  }
  .icon:hover {
    color: #263e4f;
  }
  .icon:active {
    color: green;
  }
  .img-hover-zoom {
    border: solid 1px #1e524b;
    height: 200px; /* Modify this according to your need */
    overflow: hidden; /* Removing this will break the effects */
  }
</style>
